import { createFileRoute } from "@tanstack/react-router";

import { UserManagementPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/users/")({
  component: UserManagementPage,
});
